import { Vector2 } from '@math.gl/core';

/**
 * Returns the 4 corners of a thin rectangle around a 2D line segment.
 * @param start [x, y] start point
 * @param end [x, y] end point
 * @param width width of the rectangle (meters)
 * @returns Array of 4 corners, each as [x, y]
 */
function getRectangleAroundLine2D(start: [number, number], end: [number, number], width = 0.005): [number, number][] {
    const vStart = new Vector2(start);
    const vEnd = new Vector2(end);
    const direction = new Vector2(vEnd).subtract(vStart).normalize();

    // Perpendicular vector (rotate 90 degrees)
    const perp = new Vector2([-direction.y, direction.x]).normalize().scale(width / 2);

    // Four corners (order: start-left, start-right, end-right, end-left)
    return [vStart.clone().add(perp).toArray(), vStart.clone().subtract(perp).toArray(), vEnd.clone().subtract(perp).toArray(), vEnd.clone().add(perp).toArray()] as [
        number,
        number
    ][];
}

export const MathUtils = {
    getRectangleAroundLine2D,
};
